import { useQuery } from '@tanstack/react-query';
import { getCancellationWaitlistSettings } from '../../services/cancellation-waitlist';
import useUser from '../global/useUser';

function useCancellationWaitlistSettings() {
  const { user } = useUser();
  return useQuery({
    queryKey: ['cancellation-waitlist-settings'],
    queryFn: getCancellationWaitlistSettings,
    enabled: !!user?.userId,
  });
}

export default useCancellationWaitlistSettings;
